var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStoreEmptyAvatar = function SvgStoreEmptyAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F6F9FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M36.667 21.667A6.667 6.667 0 1 1 30 15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeWidth: 2,
    d: "M18.333 38.222c0-1.434.902-2.713 2.252-3.196a27.992 27.992 0 0 1 18.83 0 3.393 3.393 0 0 1 2.252 3.196v2.192c0 1.98-1.753 3.5-3.712 3.22l-1.591-.227a45.002 45.002 0 0 0-12.728 0l-1.59.227a3.252 3.252 0 0 1-3.713-3.22v-2.192Z"
  })));
};
export default SvgStoreEmptyAvatar;